import React from "react";
import * as styles from "./pagination.module.scss";
import { Link } from "gatsby";

const Pagination = (props) => {
  return (
    <React.Fragment>
      <div className={styles.pagination}>
        {props.prePage !== "" && (
          <div className={styles.prev + " " + styles.button}>
            <Link to={props.prePage}>上一页</Link>
          </div>
        )}
        {props.nextPage !== "" && (
          <div className={styles.next + " " + styles.button}>
            <Link to={props.nextPage}>下一页</Link>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Pagination;
